import './page.scss'
import React from 'react'
import { Contrast } from '@entur/layout'

type FullPageContrastWrapperProps = {
  children: React.ReactNode
}
const FullPageContrastWrapper: React.FC<FullPageContrastWrapperProps> = (props) => {
  return (
    <>
      <Contrast className="eds-contrast full-width-div">
        <div className="auto-margin">{props.children}</div>
      </Contrast>
    </>
  )
}

export { FullPageContrastWrapper }
